<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    湖贝站<br>
站点介绍<br>
湖贝站位于深南东路与东门南路交叉路口的东侧。车站东侧有罗湖商务中心、市罗湖交通大队。东南侧有深南东路、南极路、特区进出入口公司、广东安装大厦、永安药行、广深医药大厦、东乐大厦、华乐星苑。西侧有东门南路、广田集团、北侧有湖贝路、湖润大厦。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:00	23:39	2号线	2分35秒	5分45秒<br>
莲塘	06:21	00:00	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:04	23:39	2号线	4分钟	5分钟<br>
莲塘	06:21	00:00	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:04	00:29	2号线	4分钟	5分钟<br>
莲塘	06:21	01:00	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
深南东路南侧(东）、南极路、春风路、新安路、桔子酒店、南湖街道办、东乐大厦、华乐星苑、罗湖创意文化广场、鸿昌广场、云景豪园、北京同仁堂<br><br>
B出入口:<br>
湖贝路、罗湖文化公园、深南东路北侧（东）、深圳市螺岭外国语实验学校（湖贝校区）、罗湖商务中心、罗湖交警大队、东门步行街、乐园路、东门市场、金城大厦、湖臻大厦、湖贝小学、罗湖中医院、京鹏大厦、湖润大厦、罗湖地税局、罗湖区委、厨安居<br><br>
C出入口:<br>
深南东路北侧（西）、东门步行街、盛华大厦、振华大厦、机电大厦、东方大厦、兴华广场、如家酒店、电信大厦、 外贸大厦、广田集团、麦芽口腔（罗湖机构）<br><br>
D出入口:<br>
深南东路南侧（西）、向西路、向西村、远东妇儿科医院、春风万佳、流花医院、南湖路、中建大厦、金鼎大厦、金色都汇、新园路、宝丰大厦、金城大厦、湖心大厦、阳光酒店、维也纳酒店、彭年酒店、农业银行、中国银行<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 湖贝地铁站<br>
17、220、223、29、M383、M133、85、M373、10、104、M191<br><br>
B出入口:<br>
公交站名： 湖贝中路<br>
17、104<br><br>
B出入口:<br>
公交站名： 湖贝地铁站<br>
17、220、223、29、M383、M133、85、M373、10、104、M191、高峰专线73<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>